import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";
import { Button } from "ui/components/button";
import { Checkbox } from "ui/components/checkbox";
import { Label } from "ui/components/label";
import { apiRoot } from "services/src/config";
import { useState } from "react";
import { Icon } from "components/index";
import { REDIRECT } from "icons/src";
import { toast } from "sonner";

export const ShareSurveyDialog = ({
  open,
  onOpenChange,
  surveyId,
  surveyDetails,
  onSuccess,
}) => {

  const [isSending, setIsSending] = useState(false);

  const handleSendEmail = async () => {
    try {
      setIsSending(true);
      await apiRoot.post(`/client-feedback/send-feedback-email`, {
        surveyId,
      });
      onSuccess?.();
      onOpenChange(false);
    } catch (error) {
      console.error("Failed to send email:", error);
      toast.error(error.message || "Failed to send email");
    } finally {
      setIsSending(false);
    }
  };


  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent >
        <DialogHeader>
          <DialogTitle>Share Survey</DialogTitle>
          <DialogDescription>
            Please review all questions carefully. The survey will be sent directly to the client.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2 py-4 cursor-pointer" onClick={()=>window.open(`https://docs.everest.7span.work/work/survey`, "_blank")}>
          <Icon className="h-4 w-4" icon={REDIRECT} />
          <Label
            htmlFor="preview"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Preview Email
          </Label>
        </div>
        <DialogFooter>
          <Button onClick={handleSendEmail} disabled={isSending}>
            {isSending ? "Sending..." : "Send Email to Client"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
